export function isActive(activeId, item) {
  if (activeId === item.id) {
    return true
  }
  if (!item.children) {
    return false
  }
  const result = item.children.some(child => isActive(activeId, child))
  return result
}

export function scrollToReport(partId, targetElementScroll = window) {
  let target = document.querySelector(`[data-chart-id="${partId}"]`)
  if (!target) {
    target = document.querySelector(`[data-report-section-id="${partId}"]`)
  }
  if (!target) {
    return
  }

  const sections = []
  let element = target.parentElement
  while (element) {
    if (element.dataset.reportSectionId) {
      sections.push(element)
    }
    element = element.parentElement
  }

  sections.map(item => {
    const button = item?.querySelector('button')
    if (button && button.getAttribute('aria-expanded') === 'false') {
      button.click()
    }
  })

  const button = target.querySelector('button')
  if (button && button.getAttribute('aria-expanded') === 'false') {
    button.click()
  }

  if (target) {
    const timeout = setTimeout(() => {
      targetElementScroll.scrollTo({
        top: target.offsetTop - 200,
        // behavior: 'smooth',
      })
      clearTimeout(timeout)
    }, 100)
  }
}
